import { number, string } from 'prop-types';

import { useContext, useState } from 'react';
import { Modal } from 'antd';

import { roundAndFormatPrice } from 'utils/helpers';
import { i18nContext } from 'context/i18n';
import { CloseModalSVG } from 'components/iconsSVG/close';

import styles from './style.module.css';

const AfterpayButton = ({
  totalPrice, currency, minTotal, screen,
}) => {
  const { t } = useContext(i18nContext);
  const [ modalVisible, setModalVisible ] = useState(false);
  if (totalPrice && totalPrice >= minTotal) {
    const paymentFragment = roundAndFormatPrice(totalPrice / 4, null, currency).replace(',', '.');
    return (
      <>
        {screen === 'PDP' ?
          <>
            <p className={styles.paymentLabel}>{t('ficha.producto', 'pay.in.3.6.or.8.monthly.installments.au').replace('<value>', paymentFragment)}</p>
            <div className={`${styles.paymentLabel} ${styles.afterpay}`} onClick={() => setModalVisible(true)}>
              <img height={26} src='/assets-new/img/payments/afterpay.png' alt='AfterPay Logo' />
              <span>{t('ficha.producto', 'pay.in.3.6.or.8.monthly.installments.info.au')}</span>
            </div>
          </> :
          <div className={styles.paymentLabelInline}>
            <p>
              {t('ficha.producto', 'pay.in.3.6.or.8.monthly.installments.au').replace('<value>', paymentFragment).replace('with', ' ')}
              {t('ficha.producto', 'afterpay.every.num.weeks')}
            </p>
            <span onClick={() => setModalVisible(true)}>{t('ficha.producto', 'afterpay.learn.more')}</span>
          </div>
        }
        <Modal
          visible={modalVisible}
          closeIcon={<CloseModalSVG />}
          onCancel={() => setModalVisible(false)}
          footer={null}
          wrapClassName={styles.modal}
        >
          <>
            <img className={styles.logo} height={86} src='/assets-new/img/payments/afterpay.png' alt='AfterPay Logo' />
            <div className={styles.modalTop}>
              <h1>{t('ficha.producto', 'afterpay.modaltop.h1')}</h1>
              <h5>{t('ficha.producto', 'afterpay.modaltop.h5')}</h5>
            </div>
            <div className={styles.modalCenter}>
              {[ '1', '2', '3' ].map((i) => (
                <div key={i}>
                  <h2>{t('ficha.producto', `afterpay.modalcenter.h2.${i}`)}</h2>
                  <span>{t('ficha.producto', `afterpay.modalcenter.text.${i}`)}</span>
                </div>
              ))}
            </div>
            <div className={styles.modalBottom}>
              <div><p>{t('ficha.producto', 'afterpay.modalbottom.h5')}</p></div>
              <div>
                <ol>
                  {[ '1', '2', '3' ].map((i) => (
                    <li key={`li${i}`}>{t('ficha.producto', `afterpay.modalbottom.li.${i}`)}</li>
                  ))}
                </ol>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <p>
                {t('ficha.producto', 'afterpay.modalfotter')}
                <a href='https://www.afterpay.com/terms' target='_blank' rel="noreferrer" >https://www.afterpay.com/terms</a>
              </p>
            </div>
          </>
        </Modal>
      </>
    );
  }
  return (
    <p>{t('ficha.producto', 'afterpay.not.available').replace(/<moneda>/g, currency)}</p>
  );
};

AfterpayButton.defaultProps = {
  totalPrice: 0,
  minTotal: 35,
  currency: 'AUD',
  screen: 'PDP',
};

AfterpayButton.propTypes = {
  totalPrice: number,
  minTotal: number,
  currency: string,
  screen: string,
};

export default AfterpayButton;
